import * as Yup from "yup";

export const SchemaArchitect = Yup.object().shape({

})
